import {Component, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {LoaderService, ReportService, SalesService} from '@app/shared/services';
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {CommonModule, DatePipe} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {routerTransition} from '@app/router.animations';
import {FormsModule} from '@angular/forms';
import {environment} from '@env/environment';
import {UtilsInjectable} from '@app/shared';
import numberToWords from 'number-to-words';
import {NgbHighlight, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';

@Component({
  selector: 'app-add-temp-sale',
  templateUrl: './add-temp-sale.component.html',
  styleUrls: ['./add-temp-sale.component.scss'],
  animations: [routerTransition()],
  providers: [DatePipe],
  imports: [
    CommonModule,
    FormsModule,
    NgbTypeahead,
    NgbHighlight,
    PageHeaderComponent
  ]
})
export class AddTempSaleComponent implements OnInit {
  user_rights: any;
  user_data: any;

  public now = new Date();


  warehouse_choose_data: any
  public sale_details: any = [""];
  public sale: any =
    {
      sale_id: 0,
      patient_name: '',
      payment_type: 1,
      bill_type: 1,
      patient_no: '',
      customer: '',
      doctor: '',
      sale_date: new Date(),
      discount: 0,
      freight_charge: 0,
      disc_per: 0,
      state: '',
      state_id: 19,
      state_code: 32,
      order_no: '',
      vat_no: '',
      slab: 1,
      cardno: '',
      chequeno: '',
      remark: "",
      customer_address: "",
      license_no: "",
      shipping_address: "",
      medicine_id_arr: [""],
      base_price: [""],
      slab_per: [""],
      ava_quantity_arr: [""],
      quantity_arr: ["1"],
      uom_arr: [""],
      uom_arr_name: [""],
      amount_arr: [""],
      medicine_data: [],
      price_arr: [""],
      flood_arr: [""],
      MRP: [""],
      dis_arr: [""],
      user_id: '',
      total_arr: [""],
      unitprice_arr: [""],
      product_arr: [""],
      vat_arr: [""],
      vatamt_arr: [""],
      purchase_details_id_arr: [""],
      warehouse_arr: [""],
      warehouse_details_id_arr: [""],
      warehouses_data: [],
      mark_free_of_cost: [false],
    }
  searching = false;
  searchFailed = false;
  date: any;
  unit: any;
  total_amount = 0;
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  index: any;
  status: any;
  saled: any;
  item_list: any;
  price_total = 0;

  item: any;
  gross = 0;
  net_total = 0;
  state_data: any;
  state_options: any;
  public institution = JSON.parse(localStorage.getItem('institution') || "{}");
  public logo_path = JSON.parse(localStorage.getItem('logo_path') || "{}");
  numberToWords: any;
  customer: any;
  customer_options: any;
  customer_data: any;
  warehouses_data: any = [];
  configer = {
    displayKey: "STATE_NAME",
    search: true,
    height: 'auto',
    placeholder: 'Select State',

    limitTo: 20,
    moreText: '.........',
    noResultsFound: 'No results found!',
    searchPlaceholder: 'Search',
    searchOnKey: 'STATE_NAME'
  }
  config = {
    displayKey: "CUSTOMER_NAME",
    search: true,
    height: 'auto',
    placeholder: 'Select Customer',

    limitTo: 20,
    moreText: '.........',
    noResultsFound: 'No results found!',
    searchPlaceholder: 'Search',
    searchOnKey: 'CUSTOMER_NAME'
  }

  constructor(
    private loaderService: LoaderService,
    private router: Router,
    private route: ActivatedRoute,
    public reportService: ReportService,
    public salesService: SalesService,
    private toastr: ToastrService,
    protected utils: UtilsInjectable,
  ) {

  }

  ngOnInit() {
    this.listCustomer();
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.route.params.subscribe(params => {
      this.sale.sale_id = Number.parseInt(params['sale_id']);
      this.listCustomer();

    });
    const id = +(this.route.snapshot.paramMap.get('id') || "");
    if (id != null && id != 0) {
      this.sale.sale_id = id;
      this.getSale(this.sale.sale_id);
    } else {
      this.listCustomer();
    }
  }

  public giveMarkFOC(index: any) {
    if (this.sale.mark_free_of_cost[index] == true) {
      this.sale.mark_free_of_cost[index] = true
      this.sale.vatamt_arr[index] = 0;
      this.sale.unitprice_arr[index] = 0;
      this.sale.base_price[index] = 0;
      this.sale.flood_arr[index] = 0;
      this.sale.total_arr[index] = 0;
      this.sale.price_arr[index] = 0;
      this.totalAmount();
      this.totalprice();
      this.total();
    }
    this.sale.mark_free_of_cost.forEach((_item: any, index: any): any => {
      if (this.sale.mark_free_of_cost[index] == true) {;
        this.sale.vatamt_arr[index] = 0;
        this.sale.unitprice_arr[index] = 0;
        this.sale.base_price[index] = 0;
        this.sale.flood_arr[index] = 0;
        this.sale.total_arr[index] = 0;
        this.sale.price_arr[index] = 0;
      }
    });
  }

  public getSale(sale_id: any) {
    this.cleardata();
    this.clear_sale();
    const postData = {

      sale_id: sale_id
    };

    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.salesService.getTemporarySale(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.saled = result['data'];
        this.item_list = result['data'].SALE;
        let i = 0;
        this.sale_details = ['0'];
        const sale_details = [];

        this.sale.patient_name = this.saled.PATIENT_NAME;
        this.sale.order_no = this.saled.INVOICE_NUMBER;
        this.sale.sale_date = this.saled.SALE_DATE;
        this.sale.state = this.saled.STATE_NAME;
        this.sale.state_id = 19;
        this.sale.state_code = 32;
        this.sale.chequeno = this.saled.CHEQUE_CARD_NUMBER;
        this.sale.sale_id = this.saled.TEMP_SALE_ID;
        this.sale.vat_no = this.saled.VAT_NO;
        this.sale.remark = this.saled.ONLINE_REMARK;
        this.sale.license_no = this.saled.DRUG_LICENSE_NUMBER;
        this.sale.shipping_address = this.saled.SHIPPING_ADDRESS;
        this.sale.payment_type = this.saled.PAYMENT_TYPE;
        this.sale.freight_charge = this.saled.FREIGHT_CHARGE;
        this.sale.discount = this.saled.DISCOUNT;

        for (const val of result['data'].SALE) {
          sale_details.push(i);
          this.sale.medicine_data[i] = {
            'MEDICINE_ID': val.MEDICINE_ID,
            'TRADE_NAME': val.TRADE_NAME,
            'DDC_CODE': val.DDC_CODE,
            'SCIENTIFIC_CODE': val.SCIENTIFIC_CODE,
            'SCIENTIFIC_NAME': val.SCIENTIFIC_NAME
          };
          this.sale.product_arr[i] = val.PRODUCT_CODE;
          this.sale.quantity_arr[i] = val.QUANTITY;
          this.sale.uom_arr[i] = val.UNIT_ID;
          this.sale.uom_arr_name[i] = val.UNIT_DESC;
          this.sale.MRP[i] = val.MRP;
          this.sale.purchase_details_id_arr[i] = val.PURCHASE_DETAILS_ID
          this.sale.mark_free_of_cost[i] = val.MARK_FOC
          this.sale.medicine_id_arr[i] = val.MEDICINE_ID

          this.sale.vat_arr[i] = val.VAT;
          this.sale.vatamt_arr[i] = val.VAT_AMOUNT;
       
          if (val.WAREHOSE_AVAILABLE_QUANTITY == "" || val.WAREHOSE_AVAILABLE_QUANTITY == null) {
            this.sale.ava_quantity_arr[i] = val.AVAILABLE_STOCK_QUANTITY;
          } else {
            this.sale.ava_quantity_arr[i] = val.WAREHOSE_AVAILABLE_QUANTITY;
          }
          this.sale.warehouse_arr[i] = val.WAREHOUSE_NAME;
          this.sale.warehouse_details_id_arr[i] = val.WAREHOUSE_STOCK_DETAIL_ID;
          this.sale.total_arr[i] = val.TOTAL

          this.sale.total_arr[i] = val.TOTAL
          this.sale.mark_free_of_cost[i] = val.MARK_FOC == 1;
          this.warehouselist(val.MEDICINE_ID, i);
          this.sale.unitprice_arr[i] = parseFloat(val.TOTAL) / parseInt(val.QUANTITY)
          i = i + 1;
        }
        this.sale_details = sale_details;
        this.total();
        this.totalAmount();
        this.getSum();
        this.totalprice();
        this.setCustomer();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public warehouselist(item_id: any, i: any) {
    const postData = {
      medicine_id: item_id
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.salesService.warehouselist(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.sale.warehouses_data[i] = result['data'];
        this.loaderService.display(false);
      } else {
        this.toastr.error('No available wareouses');
        this.loaderService.display(false);
      }
    });
  }

  public cleardata() {
    this.warehouse_choose_data = []
    this.sale.warehouses_data = []
    this.sale.medicine_id_arr = [""]
    this.sale.slab_per = [""]
    this.sale.base_price = [""]
    this.sale.ava_quantity_arr = [""]
    this.sale.quantity_arr = ["1"]
    this.sale.uom_arr = [""]
    this.sale.uom_arr_name = [""]
    this.sale.amount_arr = [""]
    this.sale.medicine_data = []
    this.sale.flood_arr = [""]
    this.sale.price_arr = [""]
    this.sale.MRP = [""]
    this.sale.dis_arr = [""]
    this.sale.user_id = ''
    this.sale.total_arr = [""]
    this.sale.unitprice_arr = [""]
    this.sale.product_arr = [""]
    this.sale.vat_arr = [""]
    this.sale.vatamt_arr = [""]
    this.sale.purchase_details_id_arr = [""]
    this.sale.mark_free_of_cost = [false]
  }

  public set_item_medicine($event: any, i: any) {

    this.sale.state_code = 32
    this.sale.quantity_arr[i] = '1'
    this.sale.price_arr[i] = ''
    this.sale.dis_arr[i] = ''
    this.sale.total_arr[i] = ''
    this.sale.MRP [i] = ''
    this.sale.slab_per[i] = ''
    this.sale.base_price[i] = ''
    this.sale.ava_quantity_arr[i] = ''
    this.sale.uom_arr[i] = ''
    this.sale.uom_arr_name[i] = ''
    this.sale.amount_arr[i] = ''
    this.sale.medicine_data[i] = ''
    this.sale.flood_arr[i] = ''
    this.sale.user_id = ''
    this.sale.unitprice_arr[i] = ''
    this.sale.product_arr[i] = ''
    this.sale.vat_arr[i] = ''
    this.sale.vatamt_arr[i] = ''
    const item = $event.item;

    this.sale.warehouse_arr[i] = ''
    this.sale.warehouse_details_id_arr[i] = ''
    this.sale.purchase_details_id_arr[i] = ''
    this.sale.warehouses_data[i] = [""]
    this.sale.medicine_id_arr[i] = item.MEDICINE_ID
    this.warehouselist(item.MEDICINE_ID, i);

  }

  public availableqty(i: any) {

    this.sale.quantity_arr[i] = '1'
    this.sale.price_arr[i] = ''
    this.sale.dis_arr[i] = ''
    this.sale.total_arr[i] = ''
    this.sale.MRP [i] = ''
    const postData = {
      medicine_id: this.sale.medicine_id_arr[i],
      warehouse_details_id: this.sale.warehouse_details_id_arr[i],
    };
    this.loaderService.display(true);
    this.salesService.detailedlist(postData).subscribe((result: any) => {

      this.loaderService.display(false);
      if (result["status"] == "Success") {
        const item_data = result["data"]
        this.sale.medicine_id_arr[i] = item_data.MEDICINE_ID;
        this.sale.warehouse_arr[i] = item_data.WAREHOUSE_ID;
        this.sale.product_arr[i] = item_data.PRODUCT_CODE;

        this.sale.uom_arr[i] = item_data.UNIT_ID;
        this.sale.uom_arr_name[i] = item_data.UNIT_DESC;
        this.sale.MRP[i] = item_data.MRP;
        this.sale.warehouse_details_id_arr[i] = item_data.WAREHOUSE_STOCK_DETAIL_ID;

        this.sale.vat_arr[i] = item_data.VAT;
        
        if (item_data.WAREHOSE_AVAILABLE_QUANTITY > 0) {
          this.sale.ava_quantity_arr[i] = item_data.WAREHOSE_AVAILABLE_QUANTITY;
        } else {
          this.sale.ava_quantity_arr[i] = 0;
        }
        this.sale.purchase_details_id_arr[i] = item_data.PURCHASE_DETAILS_ID;
        const vat = parseFloat(this.sale.vat_arr[i]);
        if (this.sale.slab) {
          if (this.sale.slab == 1) {
            this.sale.unitprice_arr[i] = item_data.SLAB_A_AMOUNT;
            this.sale.slab_per[i] = item_data.SLAB_A;
          }
          if (this.sale.slab == 2) {
            this.sale.unitprice_arr[i] = item_data.SLAB_B_AMOUNT;
            this.sale.slab_per[i] = item_data.SLAB_B;
          }
          if (this.sale.slab == 3) {
            this.sale.slab_per[i] = item_data.SLAB_C;
            this.sale.unitprice_arr[i] = item_data.SLAB_C_AMOUNT;
          }
        } else {
          this.sale.unitprice_arr[i] = item_data.MRP;
        }
        const unit = parseFloat(this.sale.unitprice_arr[i])
        this.sale.base_price[i] = ((unit / (vat + environment.FLOOD_CESS_PERCENTAGE + 100)) * 100).toFixed(2);
        this.sale.flood_arr[i] = ((unit / (environment.FLOOD_CESS_PERCENTAGE + 100)) * 100).toFixed(2);
        this.totalprice();
        this.totalAmount();
      } else {
        this.toastr.error('No available warehouses');
        this.loaderService.display(false);
      }
    })


  }

  public clear_sale() {
    this.customer_data = ""
    this.sale_details = ["0"];
    this.total_amount = 0;
    this.net_total = 0;
    this.state_data = ['']
    this.sale = {
      sale_id: 0,
      patient_name: '',
      payment_type: 1,
      bill_type: 1,
      patient_no: '',
      doctor: '',
      customer: '',
      sale_date: new Date(),
      discount: 0,
      freight_charge: 0,
      disc_per: 0,
      customer_address: "",
      state_id: 19,
      state_code: 32,
      order_no: '',
      vat_no: '',
      slab: 1,
      cardno: '',
      chequeno: '',
      remark: '',
      license_no: '',
      shipping_address: '',
      medicine_data: [],
      slab_per: [""],
      flood_arr: [""],
      base_price: [""],
      medicine_id_arr: [""],
      ava_quantity_arr: [""],
      quantity_arr: ["1"],
      uom_arr: [""],
      uom_arr_name: [""],
      amount_arr: [""],
      price_arr: [""],
      MRP: [""],
      dis_arr: [""],
      user_id: '',
      total_arr: [""],
      unitprice_arr: [''],
      product_arr: [""],
      vat_arr: [""],
      vatamt_arr: [""],
      purchase_details_id_arr: [""],
      warehouse_details_id_arr: [""],
      warehouse_arr: [""],
      mark_free_of_cost: [false],
      warehouses_data: [],
    }
  }

  public totalprice() {
    let sum = 0;


    this.sale.quantity_arr.forEach((_item: any, index: any): any => {
      let vat;
      let mrp = 0;
      if (this.sale.mark_free_of_cost[index] == true) {
        this.sale.vatamt_arr[index] = 0;
        this.sale.unitprice_arr[index] = 0;
        this.sale.base_price[index] = 0;
        this.sale.flood_arr[index] = 0;
        this.sale.total_arr[index] = 0;
        this.sale.price_arr[index] = 0;
      }
      if (this.sale.sale_id == 0) {
        if (parseInt(this.sale.ava_quantity_arr[index]) < parseInt(this.sale.quantity_arr[index])) {
          this.toastr.error('Invalid quantity');
          return false;
        }

      }

        vat = parseFloat(this.sale.MRP[index]) * (parseFloat(this.sale.vat_arr[index]) / 100);
        mrp = parseFloat(this.sale.MRP[index]) + vat;


      if (mrp < parseFloat(this.sale.unitprice_arr[index])) {
        this.toastr.error('Retail price should be less than or equal to MRP price');
        return false;
      } else {
        if (parseInt(this.sale.quantity_arr[index]) > 0 && parseFloat(this.sale.unitprice_arr[index]) > 0 && parseFloat(this.sale.unitprice_arr[index]) > 0 && this.sale.medicine_id_arr[index] > 0) {
          const qty = parseInt(this.sale.quantity_arr[index]);
          const base_price = parseFloat(this.sale.base_price[index]);
          if (!isNaN(qty)) {
            sum = qty * base_price;
          } else {
            sum = 0;
          }
          this.sale.price_arr[index] = sum.toFixed(2);
        }
      }

    });

  }

  public totalAmount() {
    let sum = 0
    this.sale.quantity_arr.forEach((_item: any, index: any): any => {
      if (this.sale.mark_free_of_cost[index] == true) {
        this.sale.vatamt_arr[index] = 0;
        this.sale.unitprice_arr[index] = 0;
        this.sale.base_price[index] = 0;
        this.sale.flood_arr[index] = 0;
        this.sale.total_arr[index] = 0;
        this.sale.price_arr[index] = 0;
      }
      if (parseInt(this.sale.quantity_arr[index]) > 0 && this.sale.medicine_id_arr[index] > 0) {
        const unit = parseFloat(this.sale.unitprice_arr[index]);
        const vat = parseFloat(this.sale.vat_arr[index]);
        const qty = parseInt(this.sale.quantity_arr[index])

        this.sale.base_price[index] = ((unit / (vat + environment.FLOOD_CESS_PERCENTAGE + 100)) * 100).toFixed(2);
        const base_price = parseFloat(this.sale.base_price[index])
        const flood = (base_price * (environment.FLOOD_CESS_PERCENTAGE / 100)).toFixed(2);
        this.sale.flood_arr[index] = parseFloat(flood) * qty;
        const price = parseFloat(this.sale.price_arr[index]);
        const slab_price = parseFloat(this.sale.unitprice_arr[index]);
        if (!isNaN(price)) {
          sum = price;
        }
        this.sale.state_code = 32

          if (!isNaN(vat && base_price)) {
            this.sale.vatamt_arr[index] = ((base_price * (vat / 100)) * qty).toFixed(2);
          }
     
        if (!isNaN(slab_price && qty)) {
          sum = slab_price * qty
        }
        this.sale.total_arr[index] = sum.toFixed(2);
        this.total();
      }
    });

  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public total() {
    let sum = 0;
    this.sale.quantity_arr.forEach((_item: any, index: any): any => {
      if (this.sale.mark_free_of_cost[index] == true) {
        this.sale.vatamt_arr[index] = 0;
        this.sale.unitprice_arr[index] = 0;
        this.sale.base_price[index] = 0;
        this.sale.flood_arr[index] = 0;
        this.sale.total_arr[index] = 0;
        this.sale.price_arr[index] = 0;
      }
      const total = parseFloat(this.sale.total_arr[index]);
      if (!isNaN(total)) {
        sum = sum + total
      }

    });
    this.total_amount = sum;
    const freight_charge = parseFloat(this.sale.freight_charge);
    const discount = parseFloat(this.sale.discount);
    if (discount > 0 && this.total_amount && freight_charge == 0) {
      this.net_total = 0;
      this.net_total = Math.round(this.total_amount - discount);
    } else if (freight_charge > 0 && this.total_amount && discount == 0) {

      this.net_total = Math.round((this.total_amount + freight_charge));
    } else if (freight_charge > 0 && this.total_amount && discount > 0) {
      this.net_total = Math.round((this.total_amount + freight_charge) - discount);
    } else {
      this.net_total = Math.round(this.total_amount);
    }
  }

  public saveTemporarySale(): any {
    let rel;
    if (this.sale.patient_name == '') {
      this.toastr.error('Please enter customer name')
      rel = 0;
      return false;
    }
    rel = 1;
    let stock_arr: any[] = [];
    this.sale.medicine_id_arr.forEach((_item: any, index: any): any => {
      let vat;
      let mrp = 0;
      stock_arr.push(this.sale.warehouse_details_id_arr[index]);
      if (this.sale.mark_free_of_cost[index] == false && this.sale.unitprice_arr[index] == 0) {
        this.toastr.error('Please mark the FOC or enter the retail price')
        rel = 0;
        return false;
      }
      if (this.sale.quantity_arr[index] == "" || this.sale.quantity_arr[index] == 0) {
        this.toastr.error('Enter quantity');
        rel = 0;
        return false;
      }
      if (parseInt(this.sale.ava_quantity_arr[index]) < parseInt(this.sale.quantity_arr[index])) {
        this.toastr.error('Invalid quantity');
        rel = 0;
        return false;
      }

      vat = parseFloat(this.sale.MRP[index]) * (parseFloat(this.sale.vat_arr[index]) / 100);
      mrp = parseFloat(this.sale.MRP[index]) + vat;

      if (mrp < parseFloat(this.sale.unitprice_arr[index])) {
        this.toastr.error('Retail price should be less than or equal to MRP price');
        rel = 0;
        return false;
      }
    });
    if (rel == 0) {
      return false
    }
    const data = this.checkSameWarehouse(stock_arr);
    if (data > -1) {
      this.toastr.error("Duplicate warehouse is found on " + this.sale.medicine_data[data].TRADE_NAME)
      stock_arr = []
      return false
    }
    this.sale.user_id = this.user_data.user_id
    this.sale.date = this.utils.date(this.sale.date)
    this.loaderService.display(true);
    this.salesService.saveTemporarySale(this.sale).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        this.loaderService.display(false);
        this.toastr.success(result.msg);
        this.sale.sale_id = result.data_id;
        this.sale_items();
        this.listCustomer();
        this.clear_sale();
        this.router.navigate(['temp-sale/temp-sale-list']).then();

      } else {
        this.toastr.error(result.msg);
        this.loaderService.display(false);
      }
    })
  }

  public checkSameWarehouse(stock_arr: any) {
    for (let i = 0; i < stock_arr.length; i++) {
      for (let j = 0; j < stock_arr.length; j++) {
        if (i != j) {
          if (stock_arr[i] == stock_arr[j]) {
            return i;
          }
        }
      }
    }
    return -1;
  }

  public addrow(index: any) {
    this.sale_details[index + 1] = '';
    this.sale.medicine_data[index + 1] = '';
    this.sale.uom_arr_name[index + 1] = '';
    this.sale.price_arr[index + 1] = '';
    this.sale.total_arr[index + 1] = '';
    this.sale.unitprice_arr[index + 1] = '';
    this.sale.quantity_arr[index + 1] = '1';
    this.sale.ava_quantity_arr[index + 1] = '';
    this.sale.price_arr[index + 1] = '';
    this.sale.purchase_details_id_arr[index + 1] = '';
    this.sale.mark_free_of_cost[index + 1] = false;
    this.sale.product_arr[index + 1] = '';
    this.sale.vat_arr[index + 1] = '';
    this.sale.vatamt_arr[index + 1] = '';
    this.sale.warehouse_details_id_arr[index + 1] = '';
    this.sale.warehouse_arr[index + 1] = '';
  }

  public deleterow(index: any) {
    this.sale_details.splice(index, 1);
    this.sale.medicine_data.splice(index, 1);
    this.sale.medicine_id_arr.splice(index, 1);
    this.sale.quantity_arr.splice(index, 1);
    this.sale.uom_arr_name.splice(index, 1);
    this.sale.amount_arr.splice(index, 1);
    this.sale.price_arr.splice(index, 1);
    this.sale.dis_arr.splice(index, 1);
    this.sale.total_arr.splice(index, 1);
    this.sale.unitprice_arr.splice(index, 1);
    this.sale.quantity_arr.splice(index, 1);
    this.sale.ava_quantity_arr.splice(index, 1);
    this.sale.price_arr.splice(index, 1);
    this.sale.purchase_details_id_arr.splice(index, 1);
    this.sale.mark_free_of_cost.splice(index, 1);
    this.sale.MRP.splice(index, 1);
    this.sale.product_arr.splice(index, 1);
    this.sale.vat_arr.splice(index, 1);
    this.sale.vatamt_arr.splice(index, 1);
    this.sale.warehouses_data.splice(index, 1);
    this.sale.warehouse_details_id_arr.splice(index, 1);
    this.sale.warehouse_arr.splice(index, 1);

    this.total();
  }

  public sale_items() {
    const postData = {

      sale_id: this.sale.sale_id
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.salesService.getTemporarySale(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.saled = result['data'];
        this.saled = result['data'];
        this.item_list = result['data'].SALE;
        this.getSum();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  getSum() {
    let total = 0;

    for (const item of this.item_list) {
      total = total + parseFloat(item.TOTAL);
    }
    this.gross = total
    if (this.saled) {
      this.price_total = Math.round(this.gross - this.saled.DISCOUNT)
    } else {
      this.price_total = Math.round(this.gross)
    }

    this.numberToWords = (numberToWords.toWords(this.price_total));
  }

  public selectCoinPaymentType(val: any) {
    this.sale.payment_type = val;
  }

  public listCustomer() {
    this.customer = [];
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.reportService.listCustomer().subscribe((result: any) => {
      this.status = result['status'];
      if (result['status'] == 'Success') {
        this.customer = result['data'];
        this.customer_options = this.customer;
        this.sale.order_no = result['invoice_no']['data']
        this.setCustomer();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);

      }
    });
  }

  public setCustomer() {
    if (this.sale.patient_name) {
      for (let index = 0; index < this.customer.length; index++) {
        if (this.customer[index].CUSTOMER_ID == this.sale.patient_name) {
          this.customer_data = this.customer[index];
          break;
        }
      }
    }
  }

  getCustomer() {
    this.sale_details = ["0"];
    this.total_amount = 0;
    this.net_total = 0;
    this.state_data = ['']
    this.sale = {
      sale_id: 0,
      patient_name: '',
      payment_type: 1,
      bill_type: 1,
      patient_no: '',
      doctor: '',
      customer: '',
      sale_date: new Date(),
      discount: 0,
      freight_charge: 0,
      disc_per: 0,
      customer_address: "",
      state_id: 19,
      state_code: 32,
      order_no: this.sale.order_no,
      vat_no: '',
      slab: 1,
      cardno: '',
      chequeno: '',
      remark: '',
      license_no: '',
      shipping_address: '',
      medicine_data: [],
      slab_per: [""],
      flood_arr: [""],
      base_price: [""],
      medicine_id_arr: [""],
      ava_quantity_arr: [""],
      quantity_arr: ["1"],
      uom_arr: [""],
      uom_arr_name: [""],
      amount_arr: [""],
      price_arr: [""],
      MRP: [""],
      dis_arr: [""],
      user_id: '',
      total_arr: [""],
      unitprice_arr: [''],
      product_arr: [""],
      vat_arr: [""],
      vatamt_arr: [""],
      purchase_details_id_arr: [""],
      warehouse_arr: [""],
      warehouse_details_id_arr: [""],
      mark_free_of_cost: [false],
    }
    this.sale.patient_name = this.customer_data.CUSTOMER_ID;
    this.sale.state_id = this.customer_data.STATE_ID;
    this.sale.state = this.customer_data.STATE_NAME;
    this.sale.state_code = this.customer_data.TIN_NUMBER;
    this.sale.vat_no = this.customer_data.VAT_NO;
    this.sale.license_no = this.customer_data.DRUG_LICENSE_NUMBER;
    this.sale.customer_address = this.customer_data.CUSTOMER_ADDRESS;
  }

  medicine_search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.salesService.medicine_search(term).pipe(
          map((response: any) => {
            this.searchFailed = false
            if (response.status == 'Success') {
              return response.data;
            } else {
              return [];
            }
          }),
          catchError(() => {
            this.searchFailed = true;
            return of([])
          })
        )
      ),
      tap(() => this.searching = false)
    )
  formatter = (x: any): any => x.TRADE_NAME;
}

